import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Typography, message, Spin, Button, Space } from 'antd';
import { ArrowLeftOutlined, ScheduleOutlined } from '@ant-design/icons';
import { classAPI } from '../../services/api';
import DutyStudentManagement from './DutyStudentManagement';

const { Title, Text } = Typography;

const DutyManagePage = () => {
  const { classId } = useParams();
  const navigate = useNavigate();
  const [classInfo, setClassInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (classId) {
      fetchClassInfo();
    }
  }, [classId]);

  const fetchClassInfo = async () => {
    try {
      setLoading(true);
      const response = await classAPI.getById(classId);
      if (response.data.success) {
        setClassInfo(response.data.data);
      } else {
        message.error('获取班级信息失败');
        navigate('/classes/duty');
      }
    } catch (error) {
      console.error('获取班级信息失败:', error);
      message.error('获取班级信息失败');
      navigate('/classes/duty');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!classInfo) {
    return (
      <Card>
        <p>班级信息不存在</p>
        <Button onClick={() => navigate('/classes/duty')}>返回选择班级</Button>
      </Card>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Space>
            <Button 
              type="text" 
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/classes/duty')}
            >
              返回
            </Button>
            <ScheduleOutlined style={{ fontSize: 24, color: '#1890ff' }} />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {classInfo.name} - 值日生管理
              </Title>
              <Text type="secondary">
                {classInfo.school_name} {classInfo.grade && `· ${classInfo.grade}`}
              </Text>
            </div>
          </Space>
        </div>

        <DutyStudentManagement classId={classId} classInfo={classInfo} />
      </Card>
    </div>
  );
};

export default DutyManagePage;

